export default __webpack_public_path__ + "static/media/expGreen.dffa1cc6.svg";